import {
  getPatientLabelFirstLine,
  Order,
  getProductsOrderedCountLabel,
} from "@jasper/shared";
import {
  Badge,
  Group,
  Paper,
  Stack,
  Text,
  UnstyledButton,
} from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
import { GetManyOrdersOfUserQuery, OrderStatus } from "../../generated/graphql";

interface Props {
  order: GetManyOrdersOfUserQuery["getManyOrdersOfUser"][number];
}

export const SearchResult = ({ order }: Props) => {
  const navigate = useNavigate();
  const { hovered, ref } = useHover();

  return (
    <UnstyledButton
      onClick={() => navigate(`/order/${order.id}`)}
      ref={ref}
      h="100%"
    >
      <Paper
        withBorder
        radius={0}
        h="100%"
        shadow={hovered ? "sm" : undefined}
        bg={hovered ? "primaryLight.9" : undefined}
        bd={hovered ? "1px solid var(--mantine-color-primary-5)" : undefined}
        style={{
          transform: hovered ? "translateY(-2px)" : undefined,
          transition: "transform 150ms ease",
        }}
      >
        <Group
          justify="space-between"
          align="flex-start"
          wrap="nowrap"
          m="xs"
          h="100%"
        >
          <Stack align="flex-start" gap="xs">
            <Text fw={600}>{getPatientLabelFirstLine(order)}</Text>
            {getProductsOrderedCountLabel(order as unknown as Order) && (
              <Text size="xs" c="dimmed">
                {getProductsOrderedCountLabel(order as unknown as Order)}
              </Text>
            )}
            {order.orderReference && (
              <Text size="xs" c="dimmed">
                {order.orderReference}
              </Text>
            )}
          </Stack>
          <Badge size="sm" variant="light">
            {order.status === OrderStatus.Delivered ? "Terminée" : "En cours"}
          </Badge>
        </Group>
      </Paper>
    </UnstyledButton>
  );
};
